export default($el) => ({
  el: $el,
  active: 1, // convert active to a number
  slides: $el.querySelectorAll('.ttec-rotator__slide'),
  dotNav: true,
  timerId: null,
  clickDisablesTimer: true, // if the user clicks anything, we stop the timer
  timer: 5000,
  timerStart: null,
  pauseTime: null,
  runningState: 's-stopped',
  total: 1,
  heightAdjustElement: $el.querySelector('[data-setheight-image]'),

  init(){
    let timer = this.el.dataset.timer
    timer = timer === 'false' ? false : timer
    this.timer = timer !== false ? this.timer : parseInt(timer)
    if(timer === 'false' || timer === false) {
      this.timer = false;
      this.handleStopPlay();
    }
    if(this.dotNav !== false) {
      this.buildDotNav();
      // wait for the dots to be added since
      // we're using Alpine x-for
      this.$nextTick(() => {
        this.setDotDirection();
      });
    }

    this.total = this.slides.length;
    this.addListNavEventListeners();
    if (this.timer) {
      this.startTimer();
      this.updateProgressBar();
      this.observeVisibility();
      this.runningState = 's-running';
    }

    this.adjustHeight();

  },

  setDotDirection() {
    const container = this.el.querySelector('[data-dot-nav]')
    if(!container) {
      return;
    }
    const items = container.querySelectorAll('li, p, span');
    container.dataset.layout = this.getElementsLayout(items);
  },

  startTimer() {
    this.timerId = setTimeout(() => {
      this.handleTimer();
    }, this.pauseTime || this.timer);
    this.timerStart = Date.now();
    this.pauseTime = null;
  },
  pause() {
    if (this.timerId) {
      clearTimeout(this.timerId);
      this.timerId = null;
      this.pauseTime = this.timer - (Date.now() - this.timerStart);
      this.pauseProgressBar();
      this.runningState = 's-paused';
    } else if (this.pauseTime) {
      this.startTimer();
      this.resumeProgressBar();
      this.runningState = 's-running';
    }
  },
  handleTimer() {
    this.active++;
    if (this.active > this.slides.length) {
      this.active = 1;
    }
    this.applyDirection('left');
    this.startTimer();
  },
  updateProgressBar() {
    this.el.classList.remove('s-disable-statusbar');
    const progressBars = this.el.querySelectorAll('[data-status]');
    progressBars.forEach(progressBar => {
      this.el.classList.remove('s-disable-statusbar');
      progressBar.classList.remove('opacity-0');
      progressBar.classList.remove('animate');
      void progressBar.offsetWidth;
      progressBar.classList.add('animate');
      progressBar.style.animationDuration = `${this.timer}ms`;
    });
  },
  pauseProgressBar() {
    const progressBars = this.el.querySelectorAll('[data-status]');
    progressBars.forEach(progressBar => {
      progressBar.style.animationPlayState = 'paused';
    });
  },
  resumeProgressBar() {
    const progressBars = this.el.querySelectorAll('[data-status]');
    progressBars.forEach(progressBar => {
      progressBar.style.animationPlayState = 'running';
    });
  },


  buildDotNav() {
    this.dotNav = Array.from(this.slides).map((slide, index) => {
      return {
        index: index + 1,
        click: ($event) => {
          const layout = $event.currentTarget.parentElement.dataset.layout ?? 'horizontal';
          this.handlePagination(index, layout);
        }
      };
    });
  },
  addListNavEventListeners() {
    const listItems = this.el.querySelectorAll('[data-nav-list] li');
    listItems.forEach((item, index) => {
      item.addEventListener('click', () => {
        const layout = this.getElementsLayout(listItems);
        this.handlePagination(index, layout);
      });
    });
  },
  handlePagination(index, layout ='horizontal'){
    clearTimeout(this.timerId);
    const direction =
      layout === 'vertical'
        ? (this.active < index + 1 ? 'down' : 'up')
        : (this.active < index + 1 ? 'right' : 'left')
    this.active = index + 1;
    this.applyDirection(direction);
    if(this.clickDisablesTimer) {
      this.handleStopPlay()
    } else {
      this.startTimer();
    }
  },
  handleArrow($event) {
     clearTimeout(this.timerId);
     const dir = $event.currentTarget.dataset.dir ?? 'right';
     if(dir === 'right' || dir === 'down') {
       this.active++;
       if (this.active > this.slides.length) {
         this.active = 1;
       }
     } else {
       this.active--;
       if (this.active < 1) {
         this.active = this.slides.length;
       }
     }
    this.applyDirection(dir);
    if(this.clickDisablesTimer) {
      this.handleStopPlay()
    } else {
      this.startTimer();
    }
  },

  handleStopPlay() {
    this.clearProgressBar();
    this.runningState = 's-complete';
  },
  clearProgressBar() {
    const progressBars = this.el.querySelectorAll('[data-status]');
    this.el.classList.add('s-disable-statusbar');
    progressBars.forEach(progressBar => {
      progressBar.classList.add('opacity-0');
    });
  },
  applyDirection(dir = 'right') {
    this.el.classList.remove(...['dir-right', 'dir-left', 'dir-up', 'dir-down']);
    this.el.classList.add(`dir-${dir}`);
    this.updateProgressBar();
  },
  observeVisibility() {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          if (!this.timerId) {
            this.startTimer();
          }
        } else {
          clearTimeout(this.timerId);
          this.timerId = null;
          this.clearProgressBar();
        }
      });
    }, {
      rootMargin: '0px 0px -150px 0px' // Adjust the bottom margin
    });
    observer.observe(this.el);
  },
  getElementsLayout(items) {
    if (items.length < 2) {
      return 'horizontal';
    }
    const firstItemRect = items[0].getBoundingClientRect();
    const secondItemRect = items[1].getBoundingClientRect();
    const firstItemLeft = Math.round(firstItemRect.left);
    const secondItemLeft = Math.round(secondItemRect.left);
    return (firstItemLeft === secondItemLeft) ? 'vertical' : 'horizontal';
  },
  adjustHeight() {
    if (!this.heightAdjustElement) return;

    const activeSlide = this.slides[this.active - 1];

    const img = activeSlide.querySelector('.ttec-rotator__image');
    if (!img) return;

    const imgHeight = img.offsetHeight;

    // Set the minimum height of the target element
    this.heightAdjustElement.style.maxHeight = `${imgHeight}px`;
  },
})
